import React from "react";
import EditDealer from "./EditDealer";
import EditOwner from "./EditOwner";

const EditDealerOrOwner = (props) => {
  const { formik, data } = props;
  return data.inventoryType === "Dealer's Stock" ? (
    <>
      <EditDealer formik={formik} />
      <EditOwner formik={formik} />
    </>
  ) : (
    <EditOwner formik={formik} />
  );
};

export default EditDealerOrOwner;
